module.exports = __webpack_public_path__ + "static/img/10.6fc7683.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/sp/10.png
// module id = epYO
// module chunks = 0